import React, {Component} from 'react'

import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Drawer, Form, notification, Popconfirm, Tabs, Tooltip, Switch} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane


class ShowJobRoleDetails extends Component {
  state={
    visible:true
  }
  onClose = () => {
    this.setState({
        visible: false
    })

    setTimeout(() => {
        this.props.onClose()
    }, 400)
}

  
  componentDidMount() {

  }

  render(){
    let {visible} = this.state
    return (
      <Drawer
        title={
          <div>
              <React.Fragment>
                Job Role Details: {this.props.record.jobTitle}
              </React.Fragment>
          </div>
        }
        placement="right"
        onClose={this.onClose}
        width={800}
        visible={visible}>
          <Card>
            <h3>Roles and Responsibilities</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.record.rolesAndResponsibility }} />
            <hr />
            <h3>Qualification & Skill</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.record.qualificationAndSkill }} />
            <hr />
            <h3>Eligibility</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.record.eligibility }} />
            <hr />
            <h3>SOP</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.record.sop }} />
            <hr />
            <h3>Target</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.record.target?this.props.record.target:"NA" }} />
            {/* <input 
              type='text' 
              className='form-control' 
              id='webLinkCopy'
              style={{cursor: 'pointer'}}
                onClick={() => {
                let html = <div dangerouslySetInnerHTML={{ __html: this.props.record.rolesAndResponsibility }} />
                var copyText = document.getElementById("webLinkCopy"); 
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                navigator.clipboard.writeText(copyText.value);
                notification.success({ message: "Copied To Clipboard."})
                }}
                readOnly 
                value={} 
            /> */}
          </Card>
        </Drawer>
    )
  }
}

@Form.create()
class JobRoles extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source:[],
    departments:[],
    record:{},
    showDrawer:false
  }

  apiRequest = params => {
    return new Promise(async(resolve) => {
    let data = await Request.getAllJobRoles({...params})
    this.setState({total:data.total})
    resolve(data)
    })
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateJobRole(values)
        } else {
        x = await Request.addJobRole(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: x.message
          })
          if (!this.state.id) {
            form.setFieldsValue({
              departmentId: '',
              jobTitle: '',
              rolesAndResponsibility:'',
              qualificationAndSkill:'',
              eligibility:'',
              sop:'',
              target:''
            })
            this.setState({activeTab:'0'})
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.messsage
          })
        }
      }
    })
  }

  updateShowOnWebsite = async({checked, _id}) =>{
    await Request.updateOnCarrerPageJobRole({_id, showOnWebsite:checked})
    this.table.current.reload()
  }

  deleteJobRole = async(data) =>{
    let response = await Request.deleteJobRole(data);
    if(response.success) {
      notification.success({
        message:response.message
      })
    }else {
      notification.error({
        message:response.message
      })
    }
    this.table.current.reload()
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setJobRoleDetails(detailId) {
    if(detailId) {
        Request.getJobRole({id:detailId}).then(({data,error,message})=>{
            if(!error && data) {
              this.setState({
                id:data._id,
                activeTab:'1'
              })
              this.props.form.setFieldsValue({
                departmentId:data.departmentId,
                jobTitle:data.jobTitle,
                rolesAndResponsibility:data.rolesAndResponsibility,
                qualificationAndSkill:data.qualificationAndSkill,
                eligibility:data.eligibility,
                sop:data.sop,
                // target:data.target,
              })
            }else {
              notification.error({
                message:'Error Getting Data',
                description:message
              })
            }
        })
    }
  }

  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  showDetailDrawer = (record) =>{
   this.setState({showDrawer:true, record})
  }

  async componentDidMount() {
    let params = {
        results:1000,
        count:1000
    }
   Request.getAllDepartments(params).then(resp=>{
    resp.data = resp.data.reduce((temp,vv)=>{
        temp.push({id:vv._id, display:vv.departmentName})
        return temp
    },[])
    this.setState({departments:resp.data})
   }) 
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }


  onClose = () =>{
    this.setState({showDrawer:false, record:{}}, ()=>{
      this.table.current.reload()
    })
  }

  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id,departments, record, showDrawer} = this.state;

    const inputTypes = {
      fields: [
        {
            label:'Department',
            key:'departmentId',
            type:'select',
            showSearch:true,
            options:departments,
            required:true,
            onChange:v=>{
                this.props.form.setFieldsValue({departmentId:v})
            }
        },
        {
            label:'Job Title',
            key:'jobTitle',
            required:true,
        },
        {
            label:'Roles And Responsibilities',
            key:'rolesAndResponsibility',
            type:'editor',
            required:true
        },
        {
            label:'Qualification And Skill',
            key:'qualificationAndSkill',
            type:'editor',
            required:true,
        },
        {
            label:'Eligibility',
            key:'eligibility',
            type:'editor'
        },
        {
            label:'SOP',
            key:'sop',
            type:'editor',
            required:true,
        },
        {
          label:'Target',
          key:'target',
          type:'editor',
        }
      ]
    };

    const columns = [
        {
            title:'Department',
            key:'departmentName',
            sorter:true
        },
        {
            title:'Job Title',
            key:'jobTitle',
            sorter:true
        },
        {
          title:'Details',
          key:'details',
          render:(text,record)=>(
            <Button onClick={()=>this.showDetailDrawer(record, "rolesAndResponsibility")}>Show Details</Button>
          )
        },
        // {
        //     title:'Roles & Responsibilities',
        //     key:'rolesAndResponsibility',
        //     searchTextName:'Roles & Responsibilities',
        //     render:(text,record)=>(
        //         <Button onClick={()=>this.showDetailDrawer(record, "rolesAndResponsibility")}>Show Detail</Button>
        //         // <div dangerouslySetInnerHTML={{ __html: text }} />
        //     )
        // },
        // {
        //     title:'Qualification & Skills',
        //     key:'qualificationAndSkill',
        //     render:(text,record)=>(
        //       <Button>Show Detail</Button>
        //         // <div dangerouslySetInnerHTML={{ __html: text }} />
        //     )
        // },
        // {
        //     title:'Eligibility',
        //     key:'eligibility',
        //     render:(text,record)=>(
        //       <Button>Show Detail</Button>
        //         // <div dangerouslySetInnerHTML={{ __html: text }} />
        //     )
        // },
        // {
        //     title:'Sop',
        //     key:'sop',
        //     render:(text,record)=>(
        //       <Button>Show Detail</Button>
        //         // <div dangerouslySetInnerHTML={{ __html: text }} />
        //     )
        // },
        // {
        //     title:'Target',
        //     key:'target',
        //     render:(text,record)=>(
        //       <Button>Show Detail</Button>
        //         // <div dangerouslySetInnerHTML={{ __html: text }} />
        //     )
        // },
        {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId?
          <React.Fragment>
            <RightsWrapper myRight={'jobRoles.edit'}>
              <Tooltip title="Edit Job Role">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setJobRoleDetails(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'jobRoles.delete'}>
              <Tooltip title="Delete Job Role">
                <Popconfirm
                  title="Are you sure delete this Job Role?"
                  onConfirm={() => {
                    this.deleteJobRole({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
            <Tooltip title={'Show On Website'}>
              <Switch checked={record.showOnWebsite} onChange={(checked)=>{
                this.updateShowOnWebsite({checked, _id:record._id})
              }} />
            </Tooltip>
          </React.Fragment>
          :null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Job Roles `}>
        {
          showDrawer?
          <ShowJobRoleDetails record={record} onClose={this.onClose} />
          :null
        }
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Job Roles`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Job Role'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default JobRoles
